import React from 'react';
import NumberFormat from 'react-number-format';
import { AREA_CODES } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

export default function NumberFormatPhone(props) {
    const { format, inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            isNumericString
            format={format || AREA_CODES.MX.format}
        />
    );
}
